import { 
  signInWithPopup, 
  signOut as firebaseSignOut,
  User 
} from 'firebase/auth';
import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { auth, googleProvider, db } from  '../config/firebase';

export const signInWithGoogle = async (): Promise<User> => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;
    
    await saveUserToFirestore(user);
    
    return user;
  } catch (error: any) {
    console.error('❌ Error en signInWithGoogle:', error);
    throw new Error(error.message || 'Error al iniciar sesión');
  }
};

const saveUserToFirestore = async (user: User): Promise<void> => {
  try {
    const userRef = doc(db, 'users', user.uid);
    const userDoc = await getDoc(userRef);
    
    const currentTime = serverTimestamp();
    
    if (userDoc.exists()) {
      // Usuario existe - Actualizar
      await setDoc(userRef, {
        displayName: user.displayName || 'Usuario',
        email: user.email || '',
        photoUrl: user.photoURL || '',
        updatedAt: currentTime
      }, { merge: true });
      
      console.log('✅ Usuario actualizado:', user.displayName);
    } else {
      // Usuario nuevo - Crear
      await setDoc(userRef, {
        displayName: user.displayName || 'Usuario',
        email: user.email || '',
        photoUrl: user.photoURL || '',
        admin: false,
        createdAt: currentTime,
        updatedAt: currentTime
      });
      
      console.log('✅ Usuario creado:', user.displayName);
    }
  } catch (error) {
    console.error('❌ Error guardando usuario en Firestore:', error);
  }
};

export const signOut = async (): Promise<void> => {
  await firebaseSignOut(auth);
};

export const getCurrentUser = (): User | null => {
  return auth.currentUser;
};

export const isAdmin = async (userId: string): Promise<boolean> => {
  try {
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);
    return userDoc.exists() && userDoc.data()?.admin === true;
  } catch (error) {
    return false;
  }
};